/** Same table as backend PenkiRates::BY_STEP — display yield by NFT step. */
export const PENKI_PER_DAY_BY_STEP: Record<number, number> = {
  1: 0,
  2: 1,
  3: 2,
  4: 4,
  5: 8,
  6: 20,
  7: 45,
  8: 100,
  9: 200,
  10: 400,
  11: 700,
  12: 1600,
  13: 2600,
  14: 3800,
  15: 5000,
};

export function penkiPerDayForNft(nft: {
  step?: number | null;
  penki_per_claim?: number | null;
}): number {
  if (nft.step != null && nft.step !== undefined) {
    return PENKI_PER_DAY_BY_STEP[nft.step] ?? 0;
  }

  return nft.penki_per_claim ?? 0;
}

export function formatPenki(value: number): string {
  if (Math.abs(value) < 10000) return String(value);
  return new Intl.NumberFormat('ru-RU').format(value);
}

export function formatPenkiCompact(value: number): string {
  if (value < 1000) return formatPenki(value);
  const k = value / 1000;
  return `${Number.isInteger(k) ? k : k.toFixed(1)}K`;
}

export function pluralPenka(): string {
  return 'УЙМ';
}

const MONTHS = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
];

const MONTHS_GENITIVE = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

export function formatMonthGroup(iso: string): string {
  const d = new Date(iso);
  return `${MONTHS[d.getMonth()]}, ${d.getFullYear()}`;
}

export function formatPenkiTransactionDate(iso: string): string {
  const d = new Date(iso);
  const time = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  return `${d.getDate()} ${MONTHS_GENITIVE[d.getMonth()]}, ${time}`;
}

export function formatCountdown(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return [h, m, sec].map((n) => String(n).padStart(2, '0')).join(':');
}

export function monthKey(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}
